// firebaseConfig.jsx
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCPARbmIHPrtMv5EOdzCRL2mo3v8QcpnKE",
  authDomain: "nexcard-57c91.firebaseapp.com",
  projectId: "nexcard-57c91",
  storageBucket: "nexcard-57c91.firebasestorage.app",
  messagingSenderId: "528689584839",
  appId: "1:528689584839:web:4ffe681dcce93f55743ce2",
  measurementId: "G-8ERRTZN2N9",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider };